import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Version from "../../components/Version";
import useWindowDimensions from "../../helpers/Hooks/useWindowDimensions";
import Income from "./section/Income";
import NEReport from "./section/NEReport";
import Transactions from "./section/Transactions";
import Underwriting from "./section/Underwriting";

const CustomerPortal = () => {
  const { height, width } = useWindowDimensions();
  // console.log(today);
  const NameTable = {
    Name: "Peter Parker",
    SSN: "### ### 2314",
    DOB: "02-02-2002",
    FI: "Alabama Central Credit Union ",
    accNo: "### ### 1111",
    curAccBal: "$123.51",
  };

  const [showReport, setShowReport] = useState(true);
  const [showIncome, setShowIncome] = useState(false);
  const [showUnderwriting, setShowUnderwriting] = useState(false);
  const [showTransactions, setShowTransactions] = useState(false);
  const [swipeDir, setSwipeDir] = useState("");
  const onNEReportClick = () => {
    setShowReport(true);
    setShowIncome(false);
    setShowUnderwriting(false);
    setShowTransactions(false);
  };
  const onIncomeClick = () => {
    setShowReport(false);
    setShowIncome(true);
    setShowUnderwriting(false);
    setShowTransactions(false);
  };
  const onUndeweritingClick = () => {
    setShowReport(false);
    setShowIncome(false);
    setShowUnderwriting(true);
    setShowTransactions(false);
  };
  const onTransactionsClick = () => {
    setShowReport(false);
    setShowIncome(false);
    setShowUnderwriting(false);
    setShowTransactions(true);
  };

  useEffect(() => {
    document.addEventListener("swiped", function (e) {
      console.log(e.target); // the element that was swiped
      // console.log(e.detail.dir); // swiped direction
      setSwipeDir(e.target); // swiped direction
    });
  }, []);

  return (
    <main className="relative flex flex-col h-[100vh]">
      <main className="z-50 sticky top-0">
        <section className=" bg-white">
          <Header />
        </section>
        {/* {JSON.stringify(swipeDir)} */}
        <section className="flex items-center text-xs font-semibold text-grey bg-white shadow-xl">
          {/* <section className="scrollbar mb-1 overflow-x-scroll flex items-center text-xs font-semibold text-grey bg-white shadow-md"> */}
          <div
            className={`w-fit py-4 px-2 flex flex-grow items-center justify-center border-b-2 ${
              showReport ? `text-primary border-primary` : `border-transparent`
            } cursor-pointer`}
            onClick={onNEReportClick}
          >
            <p className="w-max">Report</p>
          </div>
          <div
            className={`w-fit py-4 px-2 flex flex-grow items-center justify-center border-b-2 ${
              showIncome ? `text-primary border-primary` : `border-transparent`
            } cursor-pointer`}
            onClick={onIncomeClick}
          >
            Income
          </div>
          <div
            className={`w-fit py-4 px-2 flex flex-grow items-center justify-center border-b-2 ${
              showUnderwriting
                ? `text-primary border-primary`
                : `border-transparent`
            } cursor-pointer`}
            onClick={onUndeweritingClick}
          >
            Underwriting
          </div>
          <div
            className={`w-fit py-4 px-2 flex flex-grow items-center justify-center border-b-2 ${
              showTransactions
                ? `text-primary border-primary`
                : `border-transparent`
            } cursor-pointer`}
            onClick={onTransactionsClick}
          >
            Transactions
          </div>
        </section>
        {/* User Table */}
        {/* <div
          className={`mt-8 flex flex-col bg-white px-4 ${
            width < 323 ? `px-3.5` : ``
          }`}
        >
          <div className="overflow-x-auto">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-hidden border border-border rounded p-0 m-0">
                <table className="min-w-full">
                  <tbody className="text-left">
                    <tr className="border-b-[0.5px] border-border">
                      <th
                        scope="col"
                        className="px-4 py-[11px] text-xs font-semibold text-blackText"
                      >
                        Name :
                      </th>
                      <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.Name}
                      </td>
                    </tr>
                    <tr className="border-b-[0.5px] border-border">
                      <th
                        scope="col"
                        className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                      >
                        SSN :
                      </th>
                      <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.SSN}
                      </td>
                    </tr>
                    <tr className="">
                      <th
                        scope="col"
                        className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                      >
                        Report date :
                      </th>
                      <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {today}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}
      </main>
      <main
        className={`px-1.5 pt-2 pb-1 ${width < 323 ? `px-2.5` : ``} flex-grow`}
      >
        {showReport ? <NEReport /> : null}
        {showIncome ? <Income /> : null}
        {showUnderwriting ? <Underwriting /> : null}
        {showTransactions ? <Transactions /> : null}
      </main>
      {/* <Version /> */}
      <section className="z-40 absolute bottom-0 sticky w-full mt-1 py-[10px] text-center text-[10px] font-medium text-greySecondary bg-white topShadow">
        <div>
          This consumer report was prepared for a permissible
          {width > 485 ? null : <br />} purpose under the Fair Credit Reporting
          Act
        </div>
      </section>
    </main>
  );
};

{
  /* <section className="absolute bottom-0 h-[2px] w-full bg-primary"></section> */
}
export default CustomerPortal;

// how to increse performance using hsaura
// how to call APIs
